import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../../BaseUrl";


export default function ExamReview({setActive,setMobileActive,isAdmin}){
  const navigate = useNavigate();
  const {examId} = useParams();
  const [exam, setExam] = useState({
      id: "",
      name: "",
      unitId: "",
      uploadDate: null,
      senderId: "",
      finalGrade: 0,
    });
  
    const [questions, setQuestions] = useState([]);

    const fetchData = async()=>{
      if(examId === ""){
        return;
      }
      try{
        const response = await axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/exam-details?examId=${examId}`,{withCredentials:true});
        setExam(response.data.exam);
        setQuestions(response.data.questions);
      } catch(error){
        console.log(error);
        alert("هذا الاختبار غير موجود");
        navigate(-1);
      }
    }

    useEffect(()=>{
       fetchData();
       setActive("المواد الدراسية");
       setMobileActive("courses mobile");
      },[]);

    return (
    <div className="page-container space-y-4">
      <div style={{marginBottom:"20px"}} className="exam-info-card">
        <div style={{marginTop:"0px"}} className="exam-info">
        <h3
          style={{padding:"0px",margin:"0px"}}
        >{exam.name}</h3>

        <p className="question-title">{exam.finalGrade}:مجموع الدرجات </p>
        
        </div>
      </div>

      <div className="space-y-6">
        {questions.map((q, qIndex) => (
          <div key={qIndex} className="question-card">
              <h3 className="question-title"> {q.questionNumber}السؤال رقم </h3>

              {/* <h4 style={{textAlign:"right",marginBottom:"20px"}}>{window.MathJax.typesetPromise(q.question)}</h4> */}
                {q.photo? 
                <div className="image-preview-container">
                <img className="question-image-preview" src={`${BASE_URL}/${isAdmin?"teacher":"assistant"}/image/${q.question}`} />
                </div>
                : <h4 style={{textAlign:"right"}}>{q.question}</h4>}
                {[1, 2, 3, 4, 5].map((num, cIndex) => (
                  <div key={cIndex} className="choice-row">
                    {/* <h5>{q[`choice${num}`]}</h5> */}
                    <h5>{q[`choice${num}`]}</h5>
                    <input
                      className="choice-input-radio"
                      type="radio"
                      name={`correct-${qIndex}`}
                      checked={q.correctAnswer === q[`choice${num}`]}
                    />
                  </div>
                ))}

              <div style={{marginTop:"20px"}} className="question-degree-div">
                <p></p>
              <h4> الدرجة : {q.grade}</h4>

              </div>
            </div>
        ))}
      </div>
      <div style={{display:"flex",justifyContent:"center"}}>
        <button className="edit-exam-button-review"  style={{marginBottom:"20px",marginLeft:"0px",width:"80%"}}
        onClick={()=>navigate(`/${isAdmin?'admin-home':"assistant-home"}/edit-exam/${exam.id}`)}
        >تعديل</button>
      </div>
    </div>
  );
}